import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=09e88f81&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=09e88f81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e88f81",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/userprofile/UserProfile.vue
// module id = 1558
// module chunks = 0